// extracted by mini-css-extract-plugin
export default {"disclaimerContainer":"disclaimer_disclaimerContainer__IP9XL"};